/*
 * カスタム表示ラベル
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/custom_label`

 const custom_label = {
  namespaced: true,
  actions: {
    show ({ commit }) {
      const api_path = `${API_PATH}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    edit ({ commit }) {
      const api_path = `${API_PATH}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    update ({ commit },{ params }) {
      const api_path = `${API_PATH}/`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
}

export default custom_label

